import { render } from "./Reset_bouton.vue?vue&type=template&id=5f9bba3d"
import script from "./Reset_bouton.vue?vue&type=script&lang=js"
export * from "./Reset_bouton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__